// extracted by mini-css-extract-plugin
module.exports = {"title":"DoughnutChartStyle__title--yBgKW"};